let toastListener = null;
let confirmListener = null;
const pendingToasts = [];

const emitToast = (notification) => {
  if (toastListener) toastListener(notification);
  else pendingToasts.push(notification);
  return notification.id;
};

const createToast = (type, message, options = {}) => {
  const id = options.id || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return emitToast({ id, type, message: String(message ?? ''), ...options });
};

export const toast = {
  success: (message, options) => createToast('success', message, options),
  error: (message, options) => createToast('error', message, options),
  warning: (message, options) => createToast('warning', message, options),
  info: (message, options) => createToast('info', message, options),
  loading: (message, options) => createToast('loading', message, { duration: 0, ...options }),
  dismiss: (id) => emitToast({ id, dismiss: true }),
  promise: (promise, messages) => {
    const id = toast.loading(messages.loading || 'Working…');
    promise.then(
      (value) => toast.success(typeof messages.success === 'function' ? messages.success(value) : messages.success, { id }),
      (error) => toast.error(typeof messages.error === 'function' ? messages.error(error) : messages.error, { id })
    );
    return promise;
  }
};

export const confirmDialog = (options) => new Promise((resolve) => {
  if (!confirmListener) {
    resolve(false);
    return;
  }
  confirmListener({
    title: 'Please confirm',
    message: 'Are you sure you want to continue?',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    tone: 'danger',
    ...((typeof options === 'string') ? { message: options } : options),
    resolve
  });
});

export const registerNotificationListeners = (onToast, onConfirm) => {
  toastListener = onToast;
  confirmListener = onConfirm;
  pendingToasts.splice(0).forEach(onToast);
  return () => {
    if (toastListener === onToast) toastListener = null;
    if (confirmListener === onConfirm) confirmListener = null;
  };
};

export const inferLegacyToast = (message) => {
  const text = String(message ?? '');
  if (/success|saved|updated|uploaded|submitted|deleted|assigned|completed/i.test(text)) return toast.success(text);
  if (/fail|error|denied|unable|missing|blocked/i.test(text)) return toast.error(text);
  if (/please|select|required|cannot|does not match|not available|no data|no record|not configured|already/i.test(text)) return toast.warning(text);
  return toast.info(text);
};
